export default (state: IKeyValue) => ({
	example: state.token,
});
